const state = {
  apply_status: -1,
  fromid: -1,
  people_num: -1,
};
const mutations = {
  apply_status(state, apply_status) {
    state.apply_status = apply_status;
  },
  fromid(state, fromid) {
    state.fromid = fromid;
  },
  people_num(state, people_num) {
    state.people_num = people_num;
  },
};
const actions = {
  apply_status: ({ commit }) => commit("apply_status"),
  fromid: ({ commit }) => commit("fromid"),
  people_num: ({ commit }) => commit("people_num"),
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
